import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { ReactNode } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { cn } from 'src/utils/tailwind';
import { Checkbox } from '../ui/Checkbox';

export type CheckboxFieldProps = React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
  label: ReactNode;
  name: string;
  onChange?: (checkedState: CheckboxPrimitive.CheckedState) => void;
  isDisabled?: boolean;
};

const CheckboxField = (props: CheckboxFieldProps) => {
  const { control } = useFormContext();
  const { name, onChange, label, isDisabled, className, ...fieldProps } = props;

  return (
    <Controller
      name={name}
      control={control}
      render={({
        field: { onChange: onChangeHookForm, onBlur, value },
        formState: { isSubmitted },
        fieldState: { error, isTouched },
      }) => (
        <div className={className}>
          <div className="flex gap-2">
            <Checkbox
              {...fieldProps}
              name={name}
              id={name}
              onBlur={onBlur}
              onCheckedChange={(checkedState) => {
                onChangeHookForm(checkedState);

                if (onChange) onChange(checkedState);
              }}
              disabled={isDisabled}
              checked={!!value}
              aria-labelledby={`${name}-label`}
            />

            <label
              htmlFor={name}
              className="font-regular font-sans text-sm leading-5 peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
              id={`${name}-label`}
            >
              {label}
            </label>
          </div>

          {error && (isTouched || isSubmitted) && (
            <span className={cn('font-regular col-span-3 mt-1 font-sans text-xs leading-4 text-negative-most')}>
              {error.message}
            </span>
          )}
        </div>
      )}
    />
  );
};

export { CheckboxField };
